// extracted by mini-css-extract-plugin
export default {"pContainer":"styles_pContainer__DxeFK","title":"styles_title__Tcbf0","projects":"styles_projects__4atf0","project":"styles_project__DLgRH"};